<script>

    let loaded = false;

    // The workerSrc property shall be specified.
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/vendor/pdf/pdf.worker.js';

    export function setup(url) {

        loaded = false;

        var loadingTask = pdfjsLib.getDocument(url);

        console.log(loadingTask);

        loadingTask.promise.then(function (pdf) {

            loaded = true;

            jQuery("#pdf-viewer").empty();

            let viewer = document.getElementById('pdf-viewer');

            for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
                pdf.getPage(pageNumber).then(function (page) {

                    let canvas = document.createElement("canvas");
                    viewer.appendChild(canvas);
                    canvas.style.width = "100%";

                    var desiredWidth = jQuery(window).width() * 4;
                    var viewport = page.getViewport({scale: 1,});
                    var scale = desiredWidth / viewport.width;
                    var scaledViewport = page.getViewport({scale: scale,});

                    var context = canvas.getContext('2d');

                    canvas.height = scaledViewport.height;
                    canvas.width = scaledViewport.width;
                    var renderContext = {
                        canvasContext: context,
                        viewport: scaledViewport
                    };
                    var renderTask = page.render(renderContext);
                    renderTask.promise.then(function () {
                        console.log('Page rendered');
                        loaded = true;
                    });
                });
            }
        });
    }
</script>

<div class="flex flex-row w-full h-screen white text-white  text-base text-center justify-center bg-blue-2">
    <div class="text-5xl w-3/4 flex flex-col justify-center items-center" class:hidden={loaded}>
        Proszę czekać
    </div>

    <div id="pdf-viewer" class:hidden={!loaded}>
    </div>
</div>
